module.exports = __webpack_public_path__ + "static/img/card-bg.0f5f47bc.png";